export default class SubscriptionUtility {
    constructor(subscription) {
        this.subscription = subscription;
    }

    isFeatureWithinSubscription(featureName) {
        return this.subscription.features.some((feature) => feature === featureName)
    }
}